/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import { FRANCHISE_VIEW_PERMISSIONS } from '../../../constants/permissions';

const FranchisesView = () => import('./components/FranchisesView.vue');
const FranchiseProfile = () => import('./pages/FranchiseProfile.vue');
const FranchiseBillingPage = () => import('./pages/FranchiseBillingPage.vue');
const FranchiseFinancialPage = () => import('./pages/FranchiseFinancialPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/franchises'),
    name: 'franchises_dashboard',
    meta: {
      permissions: ['administrator', FRANCHISE_VIEW_PERMISSIONS],
    },
    component: FranchisesView,
  },
  {
    path: frontendURL('accounts/:accountId/franchises/billing'),
    name: 'franchises_billing',
    meta: {
      permissions: ['administrator', FRANCHISE_VIEW_PERMISSIONS],
    },
    component: FranchiseBillingPage,
  },
  {
    path: frontendURL('accounts/:accountId/franchises/:franchiseId/financial'),
    name: 'franchise_financial_dashboard',
    meta: {
      permissions: ['administrator', FRANCHISE_VIEW_PERMISSIONS],
    },
    component: FranchiseFinancialPage,
    props: route => ({ franchiseId: route.params.franchiseId }),
  },
  {
    path: frontendURL('accounts/:accountId/franchises/:franchiseId'),
    name: 'franchise_profile_dashboard',
    meta: {
      permissions: ['administrator', FRANCHISE_VIEW_PERMISSIONS],
    },
    component: FranchiseProfile,
    props: route => ({ franchiseId: route.params.franchiseId }),
  },
];
